'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import Immutable from 'immutable';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import UIButton from 'UIComponents/button/UIButton';
import UITextInput from 'UIComponents/input/UITextInput';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIFormControl from 'UIComponents/form/UIFormControl';
import H2 from 'UIComponents/elements/headings/H2';
import { ObjectCategory } from 'FileManagerCore/Constants';
import { objectCategoryProp } from 'FileManagerCore/constants/propTypes';
import validateFileName from 'FileManagerCore/utils/validateFileName';
import validateFolderName from 'FileManagerCore/utils/validateFolderName';
import { renameFile } from '../../actions/Files';
import { renameFolder } from '../../actions/Folders';
import { getDoesFolderNameAlreadyExist, getDoesFileNameAlreadyExist } from '../../utils/getDoesFolderOrFileNameAlreadyExist';
import { getFoldersAndFiles } from '../../selectors/FoldersAndFiles';
import { closeModal } from '../../actions/Actions';
import { getIsRenameRequestPending } from '../../selectors/ModalDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class RenameModal extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      newName: null,
      disabled: true,
      isValid: true,
      validationMessage: null
    };
    this.handleSubmit = () => {
      const {
        object,
        objectCategory
      } = this.props;
      const {
        newName
      } = this.state;
      if (objectCategory === ObjectCategory.FILE) {
        this.props.renameFile(object, newName.trim());
      } else {
        this.props.renameFolder(object, newName.trim());
      }
    };
    this.handleClose = () => {
      this.props.closeModal();
    };
    this.handleChangeName = event => {
      const {
        object,
        objectCategory,
        objects
      } = this.props;
      const newName = event.target.value;
      const trimmedNewName = newName.trim();
      let validationMessage = null;
      if (objectCategory === ObjectCategory.FILE) {
        const validationError = validateFileName(newName);
        if (validationError) {
          validationMessage = validationError.message;
        }
        if (getDoesFileNameAlreadyExist(object, objects, trimmedNewName)) {
          validationMessage = I18n.text('FileManagerDashboard.renameModal.existingFile');
        }
      } else {
        const validationError = validateFolderName(newName);
        if (getDoesFolderNameAlreadyExist(object, objects, trimmedNewName)) {
          validationMessage = I18n.text('FileManagerDashboard.folderNameValidation.existingFolder');
        } else if (validationError) {
          validationMessage = validationError.message;
        }
      }
      this.setState({
        disabled: !!validationMessage || newName.length === 0 || newName === object.get('name'),
        isValid: !validationMessage,
        validationMessage,
        newName
      });
    };
    this.handleKeyUp = e => {
      const {
        disabled,
        isValid
      } = this.state;
      if (isValid && !disabled && e.key === 'Enter') {
        this.handleSubmit();
      }
    };
  }
  render() {
    const {
      object,
      objectCategory,
      isRequestPending
    } = this.props;
    const {
      isValid,
      validationMessage,
      disabled
    } = this.state;
    const name = object.get('name');
    const categoryKey = objectCategory.toLowerCase();
    return /*#__PURE__*/_jsxs(UIModal, {
      "data-test-id": "rename-modal",
      children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
        children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
          onClick: this.handleClose
        }), /*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `FileManagerDashboard.renameModal.${categoryKey}.title`
          })
        })]
      }), /*#__PURE__*/_jsx(UIDialogBody, {
        children: /*#__PURE__*/_jsx(UIFormControl, {
          error: !isValid,
          validationMessage: validationMessage,
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `FileManagerDashboard.renameModal.${categoryKey}.label`
          }),
          children: /*#__PURE__*/_jsx(UITextInput, {
            "data-test-id": "rename-file-input",
            autoFocus: true,
            defaultValue: name,
            onChange: this.handleChangeName,
            onKeyUp: this.handleKeyUp
          })
        })
      }), /*#__PURE__*/_jsxs(UIDialogFooter, {
        children: [/*#__PURE__*/_jsx(UIButton, {
          "data-test-id": "confirm-rename-file-button",
          use: "primary",
          disabled: disabled || isRequestPending,
          onClick: this.handleSubmit,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "FileManagerDashboard.actions.rename"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          onClick: this.handleClose,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "FileManagerDashboard.actions.cancel"
          })
        })]
      })]
    });
  }
}
RenameModal.propTypes = {
  object: PropTypes.instanceOf(Immutable.Map).isRequired,
  objectCategory: objectCategoryProp.isRequired,
  objects: PropTypes.instanceOf(Immutable.List).isRequired,
  isRequestPending: PropTypes.bool.isRequired,
  renameFile: PropTypes.func.isRequired,
  renameFolder: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired
};
const mapStateToProps = (state, ownProps) => {
  return {
    objects: getFoldersAndFiles(state, ownProps).objects,
    isRequestPending: getIsRenameRequestPending(state)
  };
};
const mapDispatchToProps = {
  renameFile,
  renameFolder,
  closeModal
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RenameModal));